<template>
  <div class="fullscreen-notif position-fixed">
    <button
      v-if="show"
      type="button"
      class="close position-fixed"
      aria-label="Close"
      v-on:click="closeInfo"
    >
      <div class="icon-wrapper">
        <i class="material-icons-round">close</i>
      </div>
    </button>
    <div class="d-flex min-height">
      <div class="notif_container container-fluid px-4 mx-2">
          <div class="notif_content text-center pb-1">
            <div v-if="user.avatar" class="avatar rounded-circle position-relative overflow-hidden mx-auto mb-4">
              <span class="d-block image_background" :style="this.ImageBackground(user.avatar)"></span>
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center" style="margin-bottom: 20px;">Gefeliciteerd!<br />Je hebt {{ firstname }} aangenomen!</div>
            <div class="basic_info text-left pt-4 pb-3 mb-4">
              <p><strong>{{ user.name }}</strong></p>
              <p><a v-bind:href="`tel:` + user.mobile" class="text-derect">Telefoon: {{ user.mobile }}</a></p>
              <p><a v-bind:href="`mailto:` + user.email" class="text-derect">E-mailadres: {{ user.email }}</a></p>
              <p>Je ontvangt de contracten per e-mail.<br />Let op: mogelijk komt deze mail in de spambox terecht.</p>
            </div>
          </div>
          <div class="warning_message" v-if="create_new">
            <img src="../assets/icon-exclamationmark.png">
            <div class="warning_content">
                <p class="text-center"><b>De kandidaat kan niet alle gevraagde dagen van de vacature. Plaats nu direct een nieuwe vacature voor de overige dagen!</b></p>
                <router-link
                  :to="{ name: 'job_step-1' }"
                  title="Plaats een vacature"
                  class="btn btn-warning btn-block"
                  v-ripple="'rgba(255, 255, 255, 0.35)'"
                  >Plaats nieuwe vacature</router-link
                >
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    user: Object,
    show: Boolean,
    create_new: Boolean,
  },
  computed: {
    // a computed getter
    firstname: function() {
      // var str = this.user.name;
      // var array = str.split(" ");
      return this.user.firstname;
    }
  },
  methods: {
    async closeInfo() {
      this.$emit("input", null); // fullscreen_notif
      // send user to respecive dashboard
      if (this.user.type === 1) {
        this.$router.push({ name: "applicant-dashboard" });
      } else {
        this.$router.push({ name: "company-dashboard" });
      }
    }
  }
};
</script>

<style scoped>
.fullscreen-notif {
  background: #FFCD00;
}
.fullscreen-notif .avatar {
  width: 200px;
  height: 200px;
  border: 7.2pt solid white !important;
}
.fullscreen-notif p {
  font-size: 20px;
  line-height: 120%;
  white-space: pre-wrap;
  word-break: break-word;
}
.fullscreen-notif .text-left p {
  font-size: 15px;
  line-height: 100%;
  font-variant-numeric: lining-nums;
  font-family: "Real Head Pro";
  font-weight: 200;
}
</style>
